import { useState } from "react";
import cn from "classnames";
import Styles from "./LayoutList.module.scss";
import { Avatar } from "src/components/atoms/Avatar/Avatar";
import { Icon } from "src/components/atoms/Icon/Icon";
import { SearchResult } from "../SearchResults/SearchResult/SearchResult";
import { SchedulePreview } from "../SearchResults/SchedulePreview/SchedulePreview";
import * as Eden from "src/eden/content";
import { Sport } from "src/state/modules/team";

interface LayoutListProps {
  results: Eden.SearchResults;
  handleImport: (hit: Eden.SearchResult) => void;
}

export const LayoutList = ({ results, handleImport }: LayoutListProps) => {
  // Which team's schedule preview is expanded. Single-open accordion so the list stays compact.
  const [expandedId, setExpandedId] = useState<string | null>(null);

  return (
    <div className={cn(Styles.listContainer)}>
      {results.hits.map((item) => {
        const id = item.result.id;
        const expanded = expandedId === id;
        return (
          <div key={id} className={cn(Styles.item)}>
            <span
              className={cn(Styles.itemContainer, Styles.pointer)}
              onClick={() => handleImport(item.result)}
            >
              <div className={cn(Styles.left, Styles.avatar)}>
                <Avatar.Team source={item.result.avatar_url} sportIcon={Sport.BASEBALL} size={"medium"} />
              </div>
              <div className={cn(Styles.content)}>
                <div className={cn(Styles.middleContent)}>
                  <SearchResult results={item} />
                </div>
                <button
                  type="button"
                  className={cn(Styles.scheduleButton, { [Styles.scheduleButtonActive]: expanded })}
                  aria-label={expanded ? "Hide schedule" : "Preview schedule"}
                  aria-expanded={expanded}
                  onClick={(event) => {
                    // Preview the schedule instead of importing on this click.
                    event.stopPropagation();
                    setExpandedId(expanded ? null : id);
                  }}
                >
                  <Icon type="schedule" size="small" fill="gc-blue" />
                  <span className={cn(Styles.scheduleLabel)}>Schedule</span>
                </button>
              </div>
            </span>
            {expanded && <SchedulePreview teamId={id} />}
          </div>
        );
      })}
    </div>
  );
};
